import React, { useEffect } from "react";
import FormChangePassword from "./FormChangePassword/FormChangePassword";

import "./style.css";

const ChangePassword = () => {
  useEffect(() => {
    document.title = "Perichert | Redefinir"
  }, [])

  return (
    <div>
      <div id="page-change-password">
        <div id="change-panel" style={{ height: '360px' }}>
          <FormChangePassword />
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;